const clearStorage = async () => {
  try {
    localStorage.clear();
    sessionStorage.clear();
    return true;
  } catch (e) {
    console.log({ e });
    return false;
  }
};

const clearAllCookies = async () => {
  try {
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    });
    return true;
  } catch (e) {
    console.log({ e });
    return false;
  }
};
const closeTabsMessage = () => alert("Please close all active Storyboard tabs");

const clearIndexedDB = async () => {
  try {
    const dbs = await indexedDB.databases();
    return await Promise.all(
      dbs.map(
        (db) =>
          new Promise((resolve, reject) => {
            const request = indexedDB.deleteDatabase(db.name);
            request.onsuccess = () => resolve(true);
            request.onerror = () => {
              console.error("ERROR", db.name);
              reject("Error deleting database");
            };
            request.onblocked = () => {
              console.error("BLOCKED");
              reject("Blocked");
            };
          }),
      ),
    );
  } catch (e) {
    closeTabsMessage();
    console.log("dbError", { e });
    return false;
  }
};

const clearCaches = async () => {
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
    return true;
  } catch (e) {
    console.log({ e });
    return false;
  }
};

const clearSiteData = async (logout) => {
  const baseDomain = window?.baseDomain ?? "https://api.storyboard.com";
  const logoutLink = `${baseDomain}/auth/logout`;
  await clearStorage();

  try {
    await clearIndexedDB();
  } catch (e) {
    console.error("Error Removing IndexedDB", e);
  }
  await clearCaches();

  if (logout === true) {
    await clearAllCookies();
    window.location.href = logoutLink;
  } else {
    window.location.href = "/";
  }
};

/**
 * After the main JS has loaded, set up the debug menu
 * This is automatically injected into window from the native app
 */
const displayClearDataButtons = () => {
  const debugMenu = document.getElementById("debugMenu");
  const clickClearCacheAndReload = document.getElementById("clickClearCacheAndReload");
  const clickClearAndLogout = document.getElementById("clickClearAndLogout");

  if (debugMenu) {
    setTimeout(() => {
      debugMenu?.classList.remove("hidden");
    }, 5000);
  }

  if (clickClearCacheAndReload) {
    clickClearCacheAndReload.addEventListener("click", () => {
      clearSiteData(false);
    });
  }

  if (clickClearAndLogout) {
    clickClearAndLogout.addEventListener("click", () => {
      clearSiteData(true);
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  displayClearDataButtons();
});
